import React, { useEffect } from 'react'
import MainBanner from '../../Components/Banner/MainBanner'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import '../../assets/css/Policy.css'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { GetSiteSettingsApi } from '../../network/Network'
import { WebSiteSettings } from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton'

function PrivacyPolicy() {
  const policyData = useSelector((state) => state.AuthReducer.siteSettings?.hoho_privacy_policy);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setLoading(true);
    GetSiteSettingsApi()
      .then((res) => {
        setLoading(false);
        dispatch(WebSiteSettings(res?.data));
      })
      .catch((err) => {
        setLoading(false);
        // console.log(err);
      });
  }, []);
  return (
    <>
      <Header />
      <MainBanner name={"Privacy Policy"} />

      <section className="policy-page">
        <div className='container'>
          <h2 className='main-title'>Our Privacy Policy</h2>
          {loading ?
            <Skeleton count={5} />
            :
            <div dangerouslySetInnerHTML={{ __html: policyData }} className='para'></div>
          }
        </div>
      </section>
      <Footer />
    </>
  )
}

export default PrivacyPolicy